import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo">UK Vehicle Platform</div>

      <ul className="navbar-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/get-assistance">Roadside Help</Link></li>
        <li><Link to="/services">Vehicle Services</Link></li>
        <li><Link to="/partners">Partners</Link></li>
        <li><Link to="/coverage">Coverage Options</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
